import { render, staticRenderFns } from "./DashboardPlusV3.vue?vue&type=template&id=6a3c49b4&scoped=true"
import script from "./DashboardPlusV3.vue?vue&type=script&lang=js"
export * from "./DashboardPlusV3.vue?vue&type=script&lang=js"
import style0 from "./DashboardPlusV3.vue?vue&type=style&index=0&id=6a3c49b4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3c49b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a3c49b4')) {
      api.createRecord('6a3c49b4', component.options)
    } else {
      api.reload('6a3c49b4', component.options)
    }
    module.hot.accept("./DashboardPlusV3.vue?vue&type=template&id=6a3c49b4&scoped=true", function () {
      api.rerender('6a3c49b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/DashboardPlusV3.vue"
export default component.exports